// Copyright 2025 Mo-Sys Engineering Ltd. All Rights Reserved.
import React from "react";

export const Camera = ({ size, stroke, fill }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 48 48"
      fill={fill}
      stroke={stroke || "none"}
      strokeWidth="2px"
      strokeLinecap="round"
    >
      <path d="M3.9,11h24.5c3.5,0,6.3,2.8,6.3,6.3v18c0,.8-.7,1.5-1.5,1.5H8.5c-3.2,0-5.8-2.6-5.8-5.8V12.3c0-.7.6-1.2,1.2-1.2Z" />
      <polygon points="45.4 14.6 45.4 33 34.7 27.1 34.7 20.9 45.4 14.6" />
    </svg>
  );
};
